export const keypadActions = {
  BACKSPACE: "BACKSPACE",
};
